export default __webpack_public_path__ + "4becd46.png";